import { Badge, type BadgeProps } from '@/components/ui/badge';
import type { MigrationStatus, ModuleMigrateStatus } from '@/types';

type StatusType = MigrationStatus | ModuleMigrateStatus;

interface StatusBadgeProps {
  status: StatusType;
  className?: string | undefined;
}

type BadgeVariant = BadgeProps['variant'];

const statusConfig: Record<
  string,
  { label: string; variant: BadgeVariant }
> = {
  // Migration Status
  InProgress: { label: 'In Progress', variant: 'info' },
  Succeeded: { label: 'Succeeded', variant: 'success' },
  Partial: { label: 'Partial', variant: 'warning' },
  Failed: { label: 'Failed', variant: 'destructive' },

  // Module Migrate Status
  Pending: { label: 'Pending', variant: 'secondary' },
  Skipped: { label: 'Skipped', variant: 'outline' },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] ?? {
    label: status,
    variant: 'secondary' as BadgeVariant,
  };

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
